var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.051011 0.331373C0.0180138 0.421206 0 0.527891 0 0.649722V8.62352C0 8.74569 0.0180501 8.85245 0.0511107 8.94229L4.2473 4.63656L0.051011 0.331373ZM0.34203 9.2482C0.493946 9.30048 0.685449 9.27318 0.892966 9.15245L5.83858 6.26915L4.54184 4.93875L0.34203 9.2482ZM6.21444 6.05042L7.74607 5.15761C8.23704 4.87098 8.23704 4.40263 7.74607 4.11636L6.21386 3.22311L4.83636 4.63654L6.21444 6.05042ZM5.83823 3.00412L0.892966 0.12117C0.685379 0.000145397 0.493822 -0.0270123 0.341883 0.025411L4.54182 4.33435L5.83823 3.00412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.870f3c88d0e2af1571a0a8c6b4ac3a59.svg";
export { ForwardRef as ReactComponent };